<template>
  <div>
    <el-button icon="el-icon-question"
               @click="showSupportedTypes=true">支持哪些控件</el-button>
    <el-tabs v-model="activeName">
      <el-tab-pane label="寿险"
                   name="term_life">
        <form-with-type type="term_life"
                        v-model="productData['term_life']"
                        @submit='onSubmit' />
      </el-tab-pane>
      <el-tab-pane label="重疾险"
                   name="critical_illness">
        <form-with-type type="critical_illness"
                        v-model="productData['critical_illness']"
                        @submit='onSubmit' />
      </el-tab-pane>
      <el-tab-pane label="年金险"
                   name="annual">
        <form-with-type type="annual"
                        v-model="productData['annual']"
                        @submit='onSubmit' />
      </el-tab-pane>
      <el-tab-pane label="医疗险"
                   name="medical">
        <form-with-type type="medical"
                        v-model="productData['medical']"
                        @submit='onSubmit' />
      </el-tab-pane>
      <el-tab-pane label="意外险"
                   name="accident">
        <form-with-type type="accident"
                        v-model="productData['accident']"
                        @submit='onSubmit' />
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="支持的控件"
               :visible.sync="showSupportedTypes"
               width="80%">
      <span></span>
      <supported-types></supported-types>
    </el-dialog>
  </div>
</template>
<script>
import FormWithType from './FormWithType'
import request from '../../api/request';
import SupportedTypes from '../ui/product_item/SupportedTypes'

export default {
  name: 'ProductManagementAddProduct',
  components: {
    FormWithType,
    SupportedTypes
  },
  data() {
    return {
      showSupportedTypes: false,
      activeName: 'term_life',
      productData: {
        term_life: {
          attachments: [],
          data: {}
        },
        critical_illness: {
          attachments: [],
          data: {}
        },
        medical: {
          attachments: [],
          data: {}
        },
        accident: {
          attachments: [],
          data: {}
        },
        annual: {
          attachments: [],
          data: {}
        }
      }
    }
  },
  methods: {
    onSubmit() {
      if (Object.keys(this.productData[this.activeName].data).length === 0) {
        this.$message.error("不能保存一个空产品")
        return
      }

      request.product.post('product_add_or_modify', {
        type: this.activeName,
        data: this.productData[this.activeName].data,
        attachments: this.productData[this.activeName].attachments,
        channel: this.productData[this.activeName].channel || {}
      }).then(() => {
        this.$message.success("添加成功")
        this.productData[this.activeName] = {
          attachments: [],
          data: {}
        }
      })
    }
  },
  created() {
  }
}
</script>
<style scoped>
>>> .el-table td {
  padding: 5px 0;
}
</style>